export default __webpack_public_path__ + "static/media/8_2.27f26660.jpg";